// extracted by mini-css-extract-plugin
export default {"root":"fwcQCJ","tag":"d6Qgy7"};